import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const FilterControls = ({ onFilterChange, onRefreshIntervalChange }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('all');
  const [refreshInterval, setRefreshInterval] = useState(30);
  const [autoRefresh, setAutoRefresh] = useState(true);

  const paymentMethodOptions = [
    { value: 'all', label: 'Semua Metode Pembayaran' },
    { value: 'va', label: 'VA Transfer' },
    { value: 'qris', label: 'QRIS' },
    { value: 'ewallet', label: 'E-Wallet' },
    { value: 'card', label: 'Kartu Kredit/Debit' }
  ];

  const refreshIntervalOptions = [
    { value: 30, label: '30 detik' },
    { value: 60, label: '1 menit' },
    { value: 300, label: '5 menit' }
  ];

  const handlePaymentMethodChange = (value) => {
    setSelectedPaymentMethod(value);
    if (onFilterChange) {
      onFilterChange({ paymentMethod: value });
    }
  };

  const handleRefreshIntervalChange = (value) => {
    setRefreshInterval(value);
    if (onRefreshIntervalChange) {
      onRefreshIntervalChange(value);
    }
  };

  const toggleAutoRefresh = () => {
    const newValue = !autoRefresh;
    setAutoRefresh(newValue);
    if (onRefreshIntervalChange) {
      onRefreshIntervalChange(newValue ? refreshInterval : null);
    }
  };

  return (
    <div className="card">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex-1">
          <Select
            label="Filter Metode Pembayaran"
            options={paymentMethodOptions}
            value={selectedPaymentMethod}
            onChange={handlePaymentMethodChange}
          />
        </div>

        <div className="flex items-end gap-3">
          <div className="flex-1 lg:w-48">
            <Select
              label="Interval Refresh"
              options={refreshIntervalOptions}
              value={refreshInterval}
              onChange={handleRefreshIntervalChange}
              disabled={!autoRefresh}
            />
          </div>

          <button
            onClick={toggleAutoRefresh}
            className={`px-4 py-2 rounded-lg font-medium text-sm transition-smooth flex items-center gap-2 ${
              autoRefresh
                ? 'bg-success text-success-foreground hover:bg-success/90'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
            title={autoRefresh ? 'Auto-refresh aktif' : 'Auto-refresh nonaktif'}
          >
            <Icon name={autoRefresh ? 'RefreshCw' : 'RefreshCcw'} size={16} />
            <span className="hidden sm:inline">
              {autoRefresh ? 'Auto' : 'Manual'}
            </span>
          </button>

          <button
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg font-medium text-sm hover:bg-primary/90 transition-smooth flex items-center gap-2"
            title="Refresh sekarang"
          >
            <Icon name="RotateCw" size={16} />
            <span className="hidden sm:inline">Refresh</span>
          </button>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-muted-foreground">Filter Aktif:</span>
          {selectedPaymentMethod !== 'all' && (
            <div className="flex items-center gap-1.5 px-2 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
              <span>
                {paymentMethodOptions?.find(opt => opt?.value === selectedPaymentMethod)?.label}
              </span>
              <button
                onClick={() => handlePaymentMethodChange('all')}
                className="hover:bg-primary/20 rounded-full p-0.5 transition-smooth"
              >
                <Icon name="X" size={12} />
              </button>
            </div>
          )}
          {selectedPaymentMethod === 'all' && (
            <span className="text-xs text-muted-foreground italic">Tidak ada filter aktif</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterControls;